import React, { useEffect, useState } from "react";
import "./FloatingButtonWithPopup.css";
import ChatbotCompStream from "./ChatbotCompStream";
import * as FeatherIcon from "react-feather";
import ChatbotActionDrawer from "./ChatbotActionDrawer";
import { useParams } from "react-router-dom";
import { useUser } from "../../../../context/UserContext";

const FloatingButtonWithPopup = () => {

  const {user} = useUser()
  
  /* -------------------- helpers ---------------------------------------------------- */
  const remValue = parseFloat(
    getComputedStyle(document.documentElement).fontSize
  );
  const remToPx = (rem) => rem * remValue;
  const pxToRem = (px) => px / remValue;

  const getDefaultPopupSize = () => ({
    width: pxToRem(window.innerWidth * 0.30),
    height: pxToRem(window.innerHeight * 0.85),
  });

const getDefaultPopupPos = () => {
  const { width, height } = getDefaultPopupSize();

  // Offset from right and bottom in pixels
  const rightOffsetPx = 60; // ~1.5rem
  const bottomOffsetPx = 60; // ~2.5rem

  const x = window.innerWidth - remToPx(width) - rightOffsetPx;
  const y = window.innerHeight - remToPx(height) - bottomOffsetPx;

  return {
    x: pxToRem(x),
    y: pxToRem(y),
  };
};


  const getDefaultButtonPos = () => {
    const padding = remToPx(1.5);
    const btnWidth = remToPx(9);
    const btnHeight = remToPx(2.5);
    return {
      x: pxToRem(window.innerWidth - btnWidth - padding),
      y: pxToRem(window.innerHeight - btnHeight - padding),
    };
  };
  const {accountName,clientName} = useParams();
  /* -------------------- state ------------------------------------------------------ */
  const [btnPos, setBtnPos] = useState(getDefaultButtonPos());

  /** shows & hides the popup window */
  const [popupVisible, setPopupVisible] = useState(false);

  /** true ⇢ we already opened once; ask-button is gone forever, arrow prevails */
  const [assistantStarted, setAssistantStarted] = useState(false);

  const [popupSize, setPopupSize] = useState(getDefaultPopupSize());
  const [popupPos, setPopupPos] = useState(getDefaultPopupPos());
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [chatSessionId,setchatSessionId]=useState(null);
  const [chatAccAndClient,setChatAccAndClient]=useState({clientName:clientName||"",accountName:accountName||""});



  const [draggingBtn, setDraggingBtn] = useState(false);
  const [isDraggingPopup, setIsDraggingPopup] = useState(false);
  const [isResizing, setIsResizing] = useState(false);
  const [isMaximized, setIsMaximized] = useState(false);
  const [initialMouseDown, setInitialMouseDown] = useState(null);
  const CLICK_THRESHOLD = 5;
  const [chat, setChat] = useState([]);
  const [ sessionId , setSessionId]= useState(null);
      

  /* -------------------- resize listener ------------------------------------------ */
  useEffect(() => {
    const onResize = () => {
      if (!popupVisible) {
        setBtnPos(getDefaultButtonPos());
      }
    };
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, [popupVisible]);

  /* -------------------- mouse-move / mouse-up ------------------------------------ */
  useEffect(() => {
    const onMouseMove = (e) => {
      if (draggingBtn) {
        const x = Math.min(
          window.innerWidth - remToPx(3.75),
          Math.max(0, e.clientX - remToPx(1.875))
        );
        const y = Math.min(
          window.innerHeight - remToPx(3.75),
          Math.max(0, e.clientY - remToPx(1.875))
        );
        setBtnPos({ x: pxToRem(x), y: pxToRem(y) });
      }

      if (isDraggingPopup && !isMaximized) {
        const x = Math.min(
          window.innerWidth - remToPx(popupSize.width),
          Math.max(0, e.clientX - remToPx(6))
        );
        const y = Math.min(
          window.innerHeight - remToPx(2.5),
          Math.max(0, e.clientY - remToPx(1))
        );
        setPopupPos({ x: pxToRem(x), y: pxToRem(y) });
      }

      if (isResizing && !isMaximized) {
        const width = Math.max(
          remToPx(18),
          e.clientX - remToPx(popupPos.x)
        );
        const height = Math.max(
          remToPx(12),
          e.clientY - remToPx(popupPos.y)
        );
        const maxWidth = window.innerWidth - remToPx(popupPos.x);
        const maxHeight = window.innerHeight - remToPx(popupPos.y);
        setPopupSize({
          width: pxToRem(Math.min(width, maxWidth)),
          height: pxToRem(Math.min(height, maxHeight)),
        });
      }
    };

    const onMouseUp = (e) => {
      if (draggingBtn && initialMouseDown) {
        const dx = e.clientX - initialMouseDown.x;
        const dy = e.clientY - initialMouseDown.y;
        const distance = Math.sqrt(dx * dx + dy * dy);

        if (distance < CLICK_THRESHOLD) {
          // click → open assistant
          setChatAccAndClient({accountName:accountName||"",clientName:clientName||""})
          setAssistantStarted(true);
          setPopupVisible(true);
        }
      }
      setDraggingBtn(false);
      setIsDraggingPopup(false);
      setIsResizing(false);
      setInitialMouseDown(null);
    };

    window.addEventListener("mousemove", onMouseMove);
    window.addEventListener("mouseup", onMouseUp);
    return () => {
      window.removeEventListener("mousemove", onMouseMove);
      window.removeEventListener("mouseup", onMouseUp);
    };
  }, [
    draggingBtn,
    isDraggingPopup,
    isResizing,
    popupSize,
    popupPos,
    initialMouseDown,
  ]);

  /* -------------------- helpers -------------------------------------------------- */
  const hardClose = () => {
    /* real close – reset everything */
    const defaultBtn = getDefaultButtonPos();
    const defaultPopup = getDefaultPopupPos();
    const defaultSize = getDefaultPopupSize();

    setPopupVisible(false);
    setAssistantStarted(false);
    setBtnPos(defaultBtn);
    setPopupPos(defaultPopup);
    setPopupSize(defaultSize);
    setIsMaximized(false);
    setchatSessionId(null);
  };

  if(user?.role_key == 'ANALYST'){
    return <></>
  }

  /* -------------------- render --------------------------------------------------- */
  return (
    <>
      {/* ─────────────────────── Ask / Arrow Button ─────────────────────── */}
      {!assistantStarted && (
        <div
          className="floating-button"
          style={{ right: `1rem`, bottom: `1rem` }}
          onMouseDown={(e) => {
            e.preventDefault();
            e.stopPropagation();
            setInitialMouseDown({ x: e.clientX, y: e.clientY });
            setDraggingBtn(true);
          }}
        >
          <img src="/img/Sparkle.png" alt="Sparkle" className="mr-1" />
          Ask&nbsp;SalesPlay
        </div>
      )}

    {assistantStarted && (
      <div
        className={`floating-button ${popupVisible ? "collapsed" : "expanded"}`}
        style={{ right: `1rem`, bottom: `1rem` }}
        onClick={() => {
          setPopupVisible((v) => !v)}}
        title={popupVisible ? "Hide assistant" : "Show assistant"}
      >
        <div className="button-content">
          {popupVisible ? (
            <FeatherIcon.ChevronDown />
          ) : (
            <>
              <img src="/img/Sparkle.png" alt="Sparkle" className="mr-1" />
              Ask&nbsp;SalesPlay
            </>
          )}
        </div>
      </div>
    )}



      {/* ─────────────────────── Popup Window ─────────────────────────── */}
      {assistantStarted  && (
        <div
        className={`popup-window ${popupVisible ?   "show":"minimize"}`}
          style={{
            left: `${popupPos.x}rem`,
            top: `${popupPos.y}rem`,
            width: `${popupSize.width}rem`,
            height: `${popupSize.height}rem`,
          }}
        >
          <div
            className="popup-header"
            onMouseDown={(e) => {
              e.preventDefault();
              e.stopPropagation();
              setIsDraggingPopup(true);
            }}
          >
             <FeatherIcon.AlignRight style={{color:"white",width:"1.2rem",margin:"0.3rem", cursor:"pointer"}} onClick={() => setDrawerOpen(true)}/>
            <span>
              <img src="/img/Sparkle.png" alt="Sparkle" className="mr-1" />
              AI&nbsp;Assistant&nbsp;(BETA)
            </span>
            <div className="controls">
              {/* max / restore button if you want it back: */}
              {/* <button title={isMaximized ? "Restore" : "Maximize"} onClick={toggleMaximize}>🗖</button> */}
               
              <button title="minimize" onClick={()=>setPopupVisible(false)}>  <FeatherIcon.ChevronDown /></button>
              <button title="Close" onClick={hardClose}>
                <FeatherIcon.X className="close_chat_custom" />
              </button>
            </div>
          </div>

          <div className="popup-body">
              
           

            <ChatbotActionDrawer open={drawerOpen} onClose={() => setDrawerOpen(false)} setDrawerOpen={setDrawerOpen} setchatSessionId={setchatSessionId} chat={chat} setChat={setChat} sessionId={sessionId} setSessionId={setSessionId} setChatAccAndClient={setChatAccAndClient}/>
            <div  style={{display:"flex",flexDirection:"row",alignItems:"flex-start" , height:"100%" , justifyContent:"space-between"}}>
              <div className="sidecard-chat-button" style={{display:"flex",flexDirection:"column",justifyContent:"space-between"}} >
            
              {/* <FeatherIcon.Edit style={{color:"#4e6bca" , width:"1.2rem",margin:"0.3rem"}}/> */}
              </div>
               <ChatbotCompStream chatSessionId={chatSessionId} chat={chat} setChat={setChat} sessionId={sessionId} setSessionId={setSessionId} chatAccAndClient={chatAccAndClient}/></div>
           
          </div>

          <div
            className="resizer"
            onMouseDown={(e) => {
              e.preventDefault();
              e.stopPropagation();
              setIsResizing(true);
            }}
          />
        </div>
      )}
    </>
  );
};

export default FloatingButtonWithPopup;
